import React from 'react';
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./feminism.css";
import img from "./pics/feminism.png"
import Comment from '../../components/Comment'
const feminism = () => {
  return  (
    <div className="article-container">
        <img src={Logoar} alt="Logoar" className="logoar" />
      <div className="blue-bg">
     
        {/* <h2 className="titleart">Modern Vanvas</h2> */}
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/articles" target='_blank' data-wpel-link="internal">Articles</a></h4>
		<h1 class="entry-title">The future is not Female</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Shreya</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">23.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
    
 <br/>
  <img src={img} alt="Logoar" className="mo" />

        <div className="description1-5">
        
        <p>By now, we all would’ve come across the word ‘feminism’ at some point in our life. To some people, it is an easy topic to mock and get a laugh out of their friends. To some others, it's a topic that they don’t think much about because it doesn’t affect them. To very few people who know what feminism stands for, it's a chance at a better lifestyle for both men and women.</p>

<p> <span className='highlight-text'>The future is NOT female. The future is HUMAN.</span></p>

<p>What people fail to realize is that the past was male, and your aim should be to make the future human. Trying to prove one gender’s superiority over the other is stupid, because the human race cannot survive without either of them.</p>

<p>The mistake that society has committed is to rank a societal role as menial or superior. Getting a job and being financially independent is just as important as knowing how to manage a household.</p>

<p>If you earn a 6 figure salary but can't figure out how to cook a meal for yourself and pick up after yourself, you will be living like a pauper in a penthouse.</p>

<p>If you are adept at cooking and cleaning your space but your every financial move is dependent on someone else, you will never have a place of your own in the world.</p>

<p><span className='highlight-text'>Today, feminism is all about glorifying women who do things that are considered ‘manly’.</span> Women are degrading their own strengths, which is harming the actual feminist moment.</p>

<p>Being caring and compassionate is something that comes naturally to women, and rather than being proud of it, women degrade this part of themselves. Women who have forced themselves to become emotionless and money-hungry are applauded. The modern woman is portrayed as overly ambitious, running behind money and putting family and love on the back burner. While a career is very important, women are the only gender blessed with the power of having young ones. The father will never be able to match the love and care that a mother provides to her baby. The innate care and compassion that women come with is for this purpose, and it needs to be preserved.</p>

<p>On the flip side, men fare better in jobs that mostly need physical strength. But they have been shunned away from showing their emotional side saying that it makes them look ‘weak’. <span className='highlight-text'>Emotions and feelings are what make us human, and completely closing off this part will be a waste of all the evolution that the human brain has undergone to reach this stage.</span></p>

<p>Be it a man or woman, this type of mindset will not make anyone happy. Men and women are both human at the end of the day, and humans need connection and community above anything else.</p>

<p>So, instead of women trying to prove that they are better than men, men and women should both try to make themselves self-sufficient and develop in the areas that they are lacking, and flourish in the areas they are naturally gifted at.</p>

    <hr></hr>
</div>

        <Share/>
      </div>
</div> )}

export default feminism;